// 📁 Imports

// 💾 Variables
const inputsFile = document.querySelectorAll("[data-input-file]");

// 📐 Functions
const updateFileValue = (input, contentEl) => {
  let result = "Není vybrán žádný soubor";

  if (input.files.length !== 0) {
    const fileNames = Array.from(input.files).map((file) => file.name);
    result = fileNames.join(", ");
  } else {
    result = "Není vybrán žádný soubor";
  }

  contentEl.textContent = result;
};

// 🖱️ Event listeners
if (inputsFile.length !== 0) {
  Array.from(inputsFile).forEach((input) => {
    // Input element
    const inputEl = input
      .closest("[data-validate-input-wrapper]")
      .querySelector("[data-input-file]");

    // Trigger button for open input
    const inputTrigger = input
      .closest("[data-validate-input-wrapper]")
      .querySelector("[data-input-file-trigger]");

    // File name element
    const fileNameEl = input
      .closest("[data-validate-input-wrapper]")
      .querySelector("[data-input-file-name]");

    // Input file wrapper
    const inputFileWrapper = input.closest("[data-validate-input-wrapper]");

    // On click open choose file
    inputTrigger?.addEventListener("click", () => inputEl.click());

    // On change updateValue
    inputEl.addEventListener("change", (e) => {
      if (fileNameEl) {
        updateFileValue(e.currentTarget, fileNameEl);
      }
    });

    // On dragover add style
    inputFileWrapper.addEventListener("dragover", (e) => {
      e.preventDefault();
      inputFileWrapper.classList.add("drag");
    });

    // On dragleave remove style
    inputFileWrapper.addEventListener("dragleave", (e) => {
      e.preventDefault();
      inputFileWrapper.classList.remove("drag");
    });

    // On drop update value
    inputFileWrapper.addEventListener("drop", (e) => {
      e.preventDefault();

      inputEl.files = e.dataTransfer.files;
      if (fileNameEl) updateFileValue(inputEl, fileNameEl);
    });

    // Initial value
    if (fileNameEl) {
      updateFileValue(inputEl, fileNameEl);
    }
  });
}
